import { render, staticRenderFns } from "./_DetailsRefont.vue?vue&type=template&id=75893813"
import script from "./_DetailsRefont.vue?vue&type=script&lang=js"
export * from "./_DetailsRefont.vue?vue&type=script&lang=js"
import style0 from "./_DetailsRefont.vue?vue&type=style&index=0&id=75893813&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports